<template>
  <div v-if="isPreparing">
    <Preparing></Preparing>
  </div>
  <div v-if="!isPreparing">
    <div class="container-fluid">
      <div class="card card-item">
        <div class="card-body">
          <h3 class="fs-22 font-weight-regular pb-2">دوره های آموزشی</h3>
          <div class="divider"></div>
          <DataTable
            ref="dt"
            :filters="filters"
            class="p-datatable-lg"
            :value="courses"
            :paginator="true"
            :rows="8"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="نمایش {first} تا {last} از {totalRecords}"
            stateStorage="local"
            stateKey="dt-state-demo-local"
          >
            <template #header>
              <div
                class="
                  table-header
                  flex flex-column
                  md:flex-row md:justiify-content-between
                "
              >
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText
                    class="form-control-register"
                    v-model="filters['global'].value"
                    placeholder="جستجو کنید"
                  />
                </span>
              </div>
            </template>
            <Column
              :style="{ textAlign: 'right' }"
              field="Name"
              header="عنوان"
            ></Column>
            <Column
              :style="{ textAlign: 'right' }"
              field="Category"
              header="دسته بندی"
            ></Column>
            <Column
              :style="{ textAlign: 'right' }"
              field="Status"
              header="وضعیت"
            >
              <template #body="slotProps">
                {{ formatStatus(slotProps.data.Status) }}
              </template>
            </Column>
            <Column :style="{ textAlign: 'right' }" field="Show" header="نمایش">
              <template #body="slotProps">
                <span v-if="!slotProps.data.Show" class="text-danger"
                  >عدم نمایش</span
                >
                <span v-if="slotProps.data.Show" class="text-success"
                  >نمایش</span
                >
              </template>
            </Column>
            <Column :style="{ textAlign: 'right' }" field="Price" header="قیمت">
              <template #body="slotProps">
                {{ formatPrice(slotProps.data.Price) }}
              </template>
            </Column>
            <Column
              :style="{ textAlign: 'right' }"
              field="Discount"
              header="تخفیف"
            >
              <template #body="slotProps">
                {{ formatPrice(slotProps.data.Discount) }}
              </template>
            </Column>
            <Column
              :style="{ textAlign: 'right' }"
              field="Language"
              header="زبان"
            >
              <template #body="slotProps">
                {{ formatLang(slotProps.data.Language) }}
              </template>
            </Column>
            <Column :style="{ textAlign: 'right' }" field="Time" header="زمان">
              <template #body="slotProps">
                {{ formatTime(slotProps.data.Time) }}
              </template>
            </Column>
            <Column
              :style="{ textAlign: 'center' }"
              header="ویرایش"
              :exportable="false"
            >
              <template #body="slotProps">
                <div
                  class="
                    icon-element icon-element-sm
                    shadow-sm
                    cursor-pointer
                    ml-1
                    text-secondary
                  "
                  data-toggle="tooltip"
                  data-placement="top"
                  data-title="ویرایش"
                >
                  <i
                    data-toggle="modal"
                    data-target="#itemEditModal"
                    @click="editCourse(slotProps.data)"
                    class="la la-edit"
                  ></i>
                </div>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "../router/index";
import { FilterMatchMode } from "primevue/api";
import ls from "localstorage-slim";
import Preparing from "../components/Preparing.vue";
import { courseStatuses } from "../constants";

export default {
  name: "MyCourses",
  components: {
    Preparing,
  },
  data() {
    return {
      courseStatus: courseStatuses,
      isPreparing: true,
      me: {},
      courses: [],
      filters: {},
      course: {},
      submitted: false,
      deleteCourseDialog: false,
      selectedCourse: "",
      languages: [
        { name: "فارسی", code: 0 },
        { name: "انگلیسی", code: 1 },
      ],
    };
  },
  mounted() {
    this.getCredentials();
  },
  created() {
    this.initFilters();
  },
  methods: {
    formatLang(t) {
      return this.languages.find((e) => e.code === parseInt(t)).name;
    },
    formatStatus(t) {
      return this.courseStatus.find((e) => e.Id === t).Name;
    },
    getCredentials() {
      this.me = JSON.parse(ls.get("user"));
      this.getCourses();
    },
    sendCourse(c) {
      this.selectedCourse = c;
    },
    confirmDeleteCourse(crs) {
      this.course = crs;
      this.deleteCourseDialog = true;
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
    async getCourses() {
      await axios
        .post("/api/v1/teacher/course", {
          uid: this.me.Uid,
        })
        .then((response) => {
          if (response.status === 200) {
            this.courses = response.data;
            this.isPreparing = false;
          }
        });
      //this.$toast.add({severity:'success', summary: 'Success Message', detail:'Order submitted', life: 3000});
    },
    editCourse(course) {
      ls.set("editingCourse", course);
      ls.set("editingCourseId", course.Id);

      router.push({
        name: "EditCourse",
      });
    },
    formatCurrency(value) {
      return value.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },
  },
};
</script>

<style></style>
